import ReactGA from "react-ga4";

// pageView
export const gaPageviewConfig = [
  {
    hitType: "pageview",
    page: "/home",
    title: "首頁(home)",
  },
  {
    hitType: "pageview",
    page: "/corporation",
    title: "與我們合作(corporation)",
  },
  {
    hitType: "pageview",
    page: "/about",
    title: "關於我們(about)",
  },
  {
    hitType: "pageview",
    page: "/activity",
    title: "電影活動(activity)",
  },
  {
    hitType: "pageview",
    page: "/points",
    title: "購買點數(points)",
  },
  {
    hitType: "pageview",
    page: "/checkout",
    title: "結帳(checkout)",
  },

  {
    hitType: "pageview",
    page: "/register",
    title: "註冊(register)",
  },
  {
    hitType: "pageview",
    page: "/member",
    title: "會員中心(member)",
  },
  {
    hitType: "pageview",
    page: "/login",
    title: "登入(login)",
  },
  {
    hitType: "pageview",
    page: "/reset",
    title: "重設密碼(reset)",
  },
];

// 一般 Click 事件追蹤
export const gaHandleGaClickEvent = ({ category = "Click", action, type }) => {
  ReactGA.event({
    category: category,
    action: action,
    label: type, // 標記不同的連結類型
  });
};

// 購買事件
export const gaTrackPurchase = ({
  transactionId,
  value,
  shipping = 0,
  tax = 0,
  items,
}) => {
  ReactGA.event("purchase", {
    transaction_id: transactionId,
    value: value,
    currency: "TWD",
    shipping: shipping, // 運費
    tax: tax, // 稅金
    items: items.map((item) => ({
      item_id: item.id,
      item_name: item.name,
      price: item.price,
      quantity: item.quantity,
      item_category: item.category,
    })),
  });
};

// 產品頁面瀏覽
export const gaProductView = ({ product }) => {
  ReactGA.event("view_item", {
    currency: "TWD",
    value: product.price,
    items: [
      {
        item_id: product.id,
        item_name: product.title,
        item_category: product.category,
        price: product.price,
      },
    ],
  });
};

// 加入購物車
export const gaTrackAddToCart = ({
  price,
  quantity,
  item_id,
  item_name,
  item_category,
}) => {
  ReactGA.event("add_to_cart", {
    currency: "TWD",
    value: price * quantity,
    items: [
      {
        item_id: item_id,
        item_name: item_name,
        item_category: item_category,
        price: price,
        quantity: quantity,
      },
    ],
  });
};

// 批量加入購物車
export const gaTrackBulkAddToCart = ({ items }) => {
  const totalValue = items.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  ReactGA.event("add_to_cart", {
    currency: "TWD",
    value: totalValue,
    items: items.map((item) => ({
      item_id: item.item_id,
      item_name: item.item_name,
      item_category: item.item_category,
      price: item.price,
      quantity: item.quantity,
    })),
  });
};

// 開始結帳
export const gaHandleBeginCheckout = ({ cartItems }) => {
  const totalValue = cartItems.reduce(
    (sum, item) => sum + item.price * item.amount,
    0
  );

  ReactGA.event("begin_checkout", {
    currency: "TWD",
    value: totalValue,
    items: cartItems.map((item) => ({
      item_id: item.id,
      item_name: item.title,
      item_category: item.category,
      price: item.price,
      quantity: item.amount,
    })),
  });
};
